import { inject, Injectable, signal } from "@angular/core";
import { GroupItemActions } from "./nav-items";
import { IndexDBStorage } from "@ribera-web/auth-data-access";

@Injectable({
  providedIn: 'root',
})
export class NavigationActionService {

    storage = inject(IndexDBStorage);

    constructor() {
        this.initDraft();
    }

    private async initDraft(): Promise<void> {
      const draft = await this.storage.get<GroupItemActions>('groupActions');
      if (draft) {
        this._actionsNavigation.set(structuredClone(draft));
      }
    }

    private _actionsNavigation = signal<GroupItemActions | null>(null)
    readonly actionsNavigation = this._actionsNavigation.asReadonly()

    setActionsNavigation(code: string) {
      const action = grupos.find(group => group.code === code);
      if (action) {
        this._actionsNavigation.set(action);
        this.storage.put('groupActions', action);
      }
    }

    removeActionsNavigation() {
      this._actionsNavigation.set(null);
      this.storage.remove('groupActions');
    }

    private readonly _selectedActionId = signal<string | null>(null)
    readonly selectedActionId = this._selectedActionId.asReadonly()

    selectAction(id: string): void {
      this._selectedActionId.set(id);
    }

    resetActionId(): void {
      this._selectedActionId.set(null);
    }

}

export const grupos: GroupItemActions[] = [
    {
        code: 'GATEGORIES',
        itemsActions: [
            { id: 'editar-mesa', label: 'Editar mesa', icon: 'edit', type: 'action'},
            { id: 'dividir-cuentas', label: 'Dividir Cuentas', icon: 'scissors', type: 'action'},
            { id: 'unir-mesa', label: 'Unir mesa', icon: 'link', type: 'action'},
            { id: 'mover-pedido', label: 'Mover Pedido', icon: 'move', type: 'action'}
        ]
    },
    {
        code: 'PRODUCTS',
        itemsActions: [
            { id: 'editar-mesa', label: 'Editar mesa', icon: 'edit', type: 'action'},
            { id: 'dividir-cuentas', label: 'Dividir Cuentas', icon: 'scissors', type: 'action'},
            { id: 'unir-mesa', label: 'Unir mesa', icon: 'link', type: 'action'},
            { id: 'mover-pedido', label: 'Mover Pedido', icon: 'move', type: 'action'}
        ]
    },
    {
        code: 'SUPPLIES',
        itemsActions: [
            { id: 'lista-insumos', label: 'Lista de Insumos', icon: 'list-supplies', type: 'navigation', path: '/productos/insumos'},
            { id: 'registrar-insumo', label: 'Registrar Insumo', icon: 'create-supply', type: 'navigation', path: '/productos/insumo-crear'},
            { id: 'lista-almacenes', label: 'Lista de Almacenes', icon: 'list-warehouses', type: 'action'},
        ]
    },
    {
        code: 'DISPOSABLES',
        itemsActions: [
            { id: 'lista-descartables', label: 'Lista de descartables', icon: 'list-supplies', type: 'navigation', path: '/productos/descartables'},
            { id: 'registrar-descartable', label: 'Registrar descartable', icon: 'add', type: 'navigation', path: '/productos/descartable-crear'},
        ]
    },
    {
        code: 'CONSUMABLES',
        itemsActions: [
            { id: 'lista-consumibles', label: 'Lista de consumibles', icon: 'list-supplies', type: 'navigation', path: '/productos/consumibles'},
            { id: 'registrar-consumible', label: 'Registrar consumible', icon: 'add', type: 'navigation', path: '/productos/consumible-crear'}
        ]
    },

]